/**
 * @ngdoc directive
 * @name ce-app:MessageDirective
 *
 * @description
 *
 *
 * @restrict A
 * */
/* @ngInject */
export default function MessageDirective(__env, NotifyingService, CacheService, SleuthService, SpinnerLoadingService, QueryApiService) {
    return {
        restrict: 'AE',
        scope: {
            msgId: '@',
            name: '@'
        },
        templateUrl: require('./message.html'),
        link: function (scope, elem, attr) {
            scope.hasAlert = false;
            // If a message is displayed when sleuth changes close it.
            //NotifyingService.subscribeToSleuthChanges(scope, scope.closeAlert);

            scope.getAlertLevel = function (alertLevel) {
                switch (alertLevel) {
                    case 'info' :
                        return 'alert-lt-blue';
                    case 'warning' :
                        return 'alert-' + alertLevel;
                    case 'error' :
                        return 'alert-' + alertLevel;
                    default:
                        return 'alert-lt-blue';
                }
            };

            scope.getMessage = function (event, messageObject) {
                console.group('getMessage ' + scope.name);
                if (messageObject.msgId) {
                    //console.log("has msgid");
                    if (messageObject.msgId == scope.msgId) {
                        //console.log("set message by msgId");
                        scope.setMessage(messageObject);
                    }
                } else {
                    //console.log("set message");
                    scope.setMessage(messageObject);
                }
                //console.log("hasAlert: " + scope.hasAlert);
                console.groupEnd();
            };

            scope.setMessage = function (messageObject) {
                scope.hasAlert = true;
                scope.alertLevel = messageObject.alertLevel;
                scope.alertClass = scope.getAlertLevel(messageObject.alertLevel);
                //console.log("messageText: " + messageObject.message);
                scope.messageText = messageObject.message;

                var pvWordBeforePvs = 'detected ';
                var pvWordIndStart = scope.messageText.indexOf(pvWordBeforePvs);
                var index;
                if (pvWordIndStart !== -1) {
                    // !!WARNING!! This method is dependent on the logic in the Message Builder, keep them in sync.
                    var pvList = scope.messageText.substring(
                        pvWordIndStart + pvWordBeforePvs.length,
                        scope.messageText.length - 1 // strip off the period at the end
                    );
                    var chunks = pvList.split(', ');
                    for (var i = 0; i < chunks.length; i++) {
                        index = scope.messageText.indexOf(chunks[i]);
                        var value = scope.messageText.substring(
                            index, // Where the beginning of the string is located
                            index + chunks[i].length // Where the beginning is plus the string's length
                        );
                        scope.messageText = scope.messageText
                            .replace(
                                value,
                                '<a class=\'alert-link\' href ng-click=\'onClickLink(' + i + ')\'>' + value + '</a>'
                            );
                    }
                } else {
                    index = scope.messageText.indexOf('=<b>');
                    var lastIndex;
                    var formattedValue;
                    var count = 0;
                    while (index > 0) {
                        lastIndex = scope.messageText.indexOf('</b>', index);
                        formattedValue = scope.messageText.substring(index + 4, lastIndex);
                        scope.messageText = scope.messageText.substring(0, index + 4) +
                            '<a class=\'alert-link\' href ng-click=\'onClickLink(' + count + ')\'>' + formattedValue + '</a>' +
                            scope.messageText.substring(lastIndex);
                        ++count;
                        index = scope.messageText.indexOf('=<b>', index + 1);
                    }
                }

                // destroy message
                CacheService.setMessage(undefined);
            };

            scope.onClickLink = function (index) {
                var pvList = SleuthService.getErrorDetectedParameterValues();

                if (__env.dev) {
                    console.log('found: ' + JSON.stringify(pvList[index]));
                }

                var queryParameterValues = {
                    targetMfgs: [],
                    targetDefinitionIds: [],
                    values: [
                        {
                            parameterId: pvList[index].parameterId,
                            parameterValueIds: [pvList[index].id],
                            oldParameterValueIds: []
                        }
                    ],
                    parameterValueIds: []
                };

                SpinnerLoadingService.showLoading();
                QueryApiService.executeParameterValueSearch(queryParameterValues, function (response) {
                    SleuthService.storeSleuthData(response);
                    SleuthService.buildQueryData(response);
                    SpinnerLoadingService.hideLoading();
                });
            };

            scope.closeAlert = function () {
                scope.messageText = '';
                scope.hasAlert = false;
                CacheService.setMessage(undefined);
            };

            if (CacheService.getMessage()) {
                scope.getMessage(null, CacheService.getMessage());
            }

            NotifyingService.subscribeToMessaging(scope, scope.getMessage);
            NotifyingService.subscribeToCloseMessage(scope, scope.closeAlert);
        }
    };
}
